import type { FaireProductEntity } from "../../entity_types/product";

export const p_6g0aym3i1u: FaireProductEntity = {
  token: "p_6g0aym3i1u",
  type: "product",
  name: "Vibrant Vitality Cacao - Organic Ceremonial Chocolate",
  brandToken: "b_djuc44eyt2",
  brandName: "Ora Cacao",
  imageUrl:
    "https://cdn.faire.com/fastly/a625543c84a3661948a36b055ae351d42e28cf521c9e3fa353a957b8dba81b1c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c1d6dbd7f78a3f655b1ee585e65e3e4c19130b56c378569d6c9a6ad02be541b5.png",
    "https://cdn.faire.com/fastly/1f747abb235ee5e0715737b342f0dbf39252528a60e39453e42c7a02edc40e90.png",
    "https://cdn.faire.com/fastly/157e69a539cc3d47990703e27359cfc92c1e378318f325b7dfdc1b9b2f3607fe.jpeg",
    "https://cdn.faire.com/fastly/064b94bd5eebe080422e6cf3161eab913ac1ddb843f17e65b665820a859e8621.png",
    "https://cdn.faire.com/fastly/da19511cef2ecb39425a4f2952d8ba836a6f084764cb66ad4eb6568d8dcaa2a8.jpeg",
    "https://cdn.faire.com/fastly/451f7da5b93bf1a5e18d021e02791e443811eaa73763af1cf29953d22b0dd5d8.png",
    "https://cdn.faire.com/fastly/9a4a62a3d80b98c0b8a7bbadd264b70351a390bb0a91cf1ac1e4921b6e25c81f.jpeg",
    "https://cdn.faire.com/fastly/9409e23c44dbcb2a012958c586bff70f9d891edd01c6fe7440a8dd4aa7b0de90.jpeg",
  ],
  priceDollars: 18.6,
  description:
    "Activate your vibrant vitality with this enhanced cacao that contains a full daily dose of maca (3400 mg) and ashwagandha (450mg) in a single cup. Your cells will soak up this nourishing blend made with regenerative cacao which is the perfect delivery mechanism for bringing these healing herbs deep into the body’s tissues.\n\nMaca is a Peruvian radish that has been used by indigenous Andean peoples for thousands of years for increased stamina and balancing of hormones. The particular maca we use is grown on a spring-fed family farm at 13,000 feet and is a custom blend of red, black, and yellow varieties.\n\nWith regular consumption you may notice an inner glow emanating from you :) Makes a great coffee replacement!\n\nOrganic Ingredients: Cacao Beans, Maca from Peru, Ashwagandha from India, Cacao Butter from Tanzania, Turmeric from India, Black Pepper from Indonesia.\n\n• For dark chocolate lovers.\n• Lab tested for heavy metals safety.\n• High flavanol / flavonoid.",
  tags: [],
  msrpDollars: 31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T01:35:37.014Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
